import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type Theme = 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  readonly theme$: Observable<Theme>;
  private themeSubject = new BehaviorSubject<Theme>('light');

  constructor() {
    const savedTheme = (localStorage.getItem('theme') as Theme) || 'light';

    this.themeSubject = new BehaviorSubject<Theme>(savedTheme);
    this.theme$ = this.themeSubject.asObservable();
  }


  get current(): Theme {
    return this.themeSubject.value;
  }

  setTheme(theme: Theme) {
    localStorage.setItem("theme", theme);
    this.themeSubject.next(theme);
  }

  toggleTheme() {
    const newTheme = this.current === 'light' ? 'dark' : 'light';
    localStorage.setItem("theme", newTheme)
    this.themeSubject.next(this.current === 'light' ? 'dark' : 'light');
  }
}
